/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// original (legacy) implementation
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function EqualiseLayoutRow(row, selectors) {
  var heights = {};
  var elements = {};

  for (var i = 0; i < row.length; i++) {
    var element = row[i];

    for (var j = 0; j < selectors.length; j++) {
      var selector = selectors[j];

      if (i == 0) {
        elements[selector] = [];
      }
      var child = element.querySelector(selector);
      elements[selector].push(child);
      child.removeAttribute("style");

      if (heights[selector] == undefined) {
        heights[selector] = child.offsetHeight;
      } else if (child.offsetHeight > heights[selector]) {
        heights[selector] = child.offsetHeight;
      }
    }
  }
  for (var selector in elements) {
    var list = elements[selector];
    var height = heights[selector];
    for (var i = 0; i < list.length; i++) {
      list[i].setAttribute("style", "height: " + height + "px;");
    }
  }
}

function ElementIsVisible(element) {
  var isVisible = true;
  var bcr = element.getBoundingClientRect();

  if (bcr.left > window.innerWidth) {
    // off to the right
    isVisible = false;
  } else if (bcr.right < 0) {
    // off to the left
    isVisible = false;
  } else if (bcr.top > window.innerHeight) {
    // below the bottom
    isVisible = false;
  } else if (bcr.bottom < 0) {
    // above the top
    isVisible = false;
  }
  return isVisible;
}

function EqualiseLayoutRows(mainSelector, elementsToResize) {
  var elements = document.querySelectorAll(mainSelector);
  var row = [];

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i];

    if (ElementIsVisible(element)) {
      if (row.length == 0) {
        row.push(element);
      } else if (element.offsetTop == row[0].offsetTop) {
        row.push(element);
      } else {
        EqualiseLayoutRow(row, elementsToResize);
        row = [element];
      }
    }
  }
  if (row.length > 0) {
    EqualiseLayoutRow(row, elementsToResize);
  }
}
function EqualiseSlick() {
  EqualiseLayoutRows(".rr-recommended-product", [
    ".rr-recommended-product-title",
    ".loox-rating",
    ".rr-recommended-product-variant-selector",
  ]);

  var currents = document.querySelectorAll(
    ".rr-recommended-product.slick-current"
  );
  for (var i = 0; i < currents.length; i++) {
    var current = currents[i];
    var slick = $(current).closest(".slick-slider")[0];

    slick.setAttribute("style", "height: " + current.offsetHeight + "px;");
  }
}

function SetupSlick(element, options) {
  if (element.classList.contains("slick-initialized")) {
  } else {
    var slideCount = Math.ceil(window.innerWidth / 170);

    var slickOpts = {
      dots: true,
      slidesToShow: slideCount,
      slidesToScroll: slideCount / 2,
      variableWidth: true,
      infinite: true,
      adaptiveHeight: true,
      useTransform: false,
      responsive: [
        {
          breakpoint: 667,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            adaptiveHeight: true,
            centerMode: true,
          },
        },
      ],
    };

    if (options) {
      for (var key in options) {
        slickOpts[key] = options[key];
      }
    }

    $(element).slick(slickOpts);

    if (element.getAttribute("data-event-init") == undefined) {
      //             $( element ).on( "afterChange", EqualiseSlick );
      element.setAttribute("data-event-init", true);
    }
  }
}

function CreateElement(type, cls) {
  var node = document.createElement(type);
  if (cls) {
    node.setAttribute("class", cls);
  }
  return node;
}

function AddProduct(target, product) {
  var wrapper = CreateElement("div", "rr-recommended-product");
  var imgWrapper = CreateElement("div", "rr-recommended-product-image");
  var imgInner = CreateElement("div", "rr-recommended-product-image-inner");
  var img = CreateElement("img");
  var detail = CreateElement("div", "rr-recommended-product-detail");
  var titleWrap = CreateElement("div", "rr-recommended-product-title");
  var title = CreateElement("p");
  var rating = CreateElement("div", "loox-rating");
  var priceBox = CreateElement("div", "price-box");
  var priceWrap = CreateElement("div", "price-wrapper");
  var priceSpan = CreateElement("div", "special-price");
  var selectWrap = CreateElement(
    "div",
    "rr-recommended-product-variant-selector"
  );
  var select = CreateElement("select");
  var buttonWrap = CreateElement("div", "rr-recommended-product-add-to-cart");
  var button = CreateElement(
    "button",
    "btn btn-sm add_to_cart add_to_cart_product_page"
  );
  var qtyDiv = CreateElement(
    "div",
    "rr-custom-collection-product-qty-controls qty-changer"
  );
  var decrease = CreateElement("input", "decrease");
  var qty = CreateElement("input", "qty-input");
  var increase = CreateElement("input", "increase");

  var form = CreateElement("form", "form");
  form.setAttribute("action", "/cart/add");
  form.setAttribute("method", "post");

  var id = CreateElement("input", "hidden");
  id.value = product.variants[0].id;
  id.setAttribute("name", "id");
  form.appendChild(id);

  img.setAttribute("src", product.image);
  imgInner.appendChild(img);
  imgWrapper.appendChild(imgInner);
  wrapper.appendChild(imgWrapper);
  wrapper.setAttribute("data-pid", product.product_id);

  title.appendChild(document.createTextNode(product.title));
  titleWrap.appendChild(title);
  detail.appendChild(titleWrap);

  detail.appendChild(rating);

  var priceStr = "\u00A3" + product.variants[0].price;
  priceSpan.appendChild(document.createTextNode(priceStr));
  priceWrap.appendChild(priceSpan);
  priceBox.appendChild(priceWrap);
  detail.appendChild(priceBox);

  for (var i = 0; i < product.variants.length; i++) {
    var opt = CreateElement("option");
    opt.setAttribute("value", product.variants[i].id);
    opt.setAttribute("data-price", product.variants[i].price);
    opt.appendChild(document.createTextNode(product.variants[i].title));
    select.appendChild(opt);
  }

  if (product.variants.length == 1) {
    selectWrap.classList.add("rr-hidden-variant-selector");
  } else {
    $(select).on("change", RP_VariantChanged);
  }

  selectWrap.appendChild(select);
  form.appendChild(selectWrap);

  detail.appendChild(form);

  decrease.setAttribute("type", "button");
  decrease.setAttribute("value", "-");
  increase.setAttribute("type", "button");
  increase.setAttribute("value", "+");
  qty.setAttribute("type", "number");
  qty.setAttribute("value", "1");
  qty.setAttribute("name", "quantity");
  qtyDiv.appendChild(decrease);
  qtyDiv.appendChild(qty);
  qtyDiv.appendChild(increase);

  form.appendChild(qtyDiv);

  detail.appendChild(form);

  var v = product.variants[0];
  button.innerHTML = "<i class='icon icon-cart'></i><span>Add</span>";
  button.setAttribute("data-variant-id", v.id);
  button.setAttribute("data-product-id", product.product_id);
  button.setAttribute("data-price", v.price);
  button.setAttribute("data-sku", v.sku);
  button.setAttribute("data-grams", v.grams);
  buttonWrap.appendChild(button);

  form.appendChild(buttonWrap);
  detail.appendChild(form);

  wrapper.appendChild(detail);

  $(imgWrapper).wrap('<a href="/products/' + product.handle + '"></a>');
  $(titleWrap).wrap('<a href="/products/' + product.handle + '"></a>');

  if (target.classList.contains("slick-initialized")) {
    $(target).slick("slickAdd", wrapper);
  } else {
    target.appendChild(wrapper);
  }
}

function AddRecommendedProducts(products, target) {
  for (var i = 0; i < products.length; i++) {
    var product = products[i];
    var selector =
      ".rr-recommended-product[data-pid='" + product.product_id + "']";
    var existing = document.querySelector(selector);

    if (!existing) {
      //             console.log( "add product " + product.title + " (id " + product.product_id + ")" );
      AddProduct(target, product);
    }
  }
}

function original_ShowProductRecommendations(result) {
  if (result && result.products) {
    //console.log( "show products : " + JSON.stringify( result ) );

    var rootYMAL = document.getElementById("rr-basket-recommendations-ymal");
    var rootDYF = document.getElementById("rr-basket-recommendations-dyf");
    var targetYMAL = rootYMAL.querySelector(
      ".rr-basket-recommendations-products"
    );
    var targetDYF = rootDYF.querySelector(
      ".rr-basket-recommendations-products"
    );

    if (result.products.orders.length + result.products.browse.length < 6) {
      // not enough "did you forget" products, so just show everything in "you may also like"
      targetDYF = targetYMAL;
      rootYMAL.setAttribute("style", "width: 100%;");
      rootDYF.classList.add("hidden");
    }

    AddRecommendedProducts(result.products.also, targetYMAL);
    AddRecommendedProducts(result.products.orders, targetYMAL);
    AddRecommendedProducts(result.products.browse, targetYMAL);

    var dyfCount = rootDYF
      .querySelector(".rr-basket-recommendations-products")
      .querySelectorAll(".rr-recommended-product").length;
    if (dyfCount > 0) {
      rootDYF.classList.remove("hidden");

      SetupSlick(targetDYF);
    }
    var ymalCount = targetYMAL.querySelectorAll(
      ".rr-recommended-product"
    ).length;
    if (ymalCount > 0) {
      rootYMAL.classList.remove("hidden");

      if (
        $(
          "#rr-basket-recommendations-ymal .rr-basket-recommendations-products"
        ).children().length
      ) {
        if (
          $(
            "#rr-basket-recommendations-ymal .rr-basket-recommendations-products"
          ).hasClass("slick-initialized")
        ) {
          // unslick the slider if it already has slick
          $(
            "#rr-basket-recommendations-ymal .rr-basket-recommendations-products"
          ).slick("unslick");
        }
        $(
          "#rr-basket-recommendations-ymal .rr-basket-recommendations-products"
        ).slick({
          dots: true,
          infinite: false,
          speed: 300,
          slidesToShow: 8,
          slidesToScroll: 4,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ],
        });
        // equals the height of divs
        $(
          "#rr-basket-recommendations-ymal .rr-basket-recommendations-products .rr-recommended-product-title"
        ).matchHeight();
        $(
          "#rr-basket-recommendations-ymal .rr-basket-recommendations-products .rr-recommended-product-variant-selector"
        ).matchHeight();
        // slider is loaded
        $(
          "#rr-basket-recommendations-ymal .rr-basket-recommendations-products"
        ).removeClass("ploading");
      }
    }
    SetATCHandlers();
  }
}

function GetCart(cb) {
  var xhr = new XMLHttpRequest();
  xhr.onreadystatechange = function () {
    if (xhr.readyState == 4) {
      if (xhr.status == 200) {
        var parsed;
        try {
          parsed = JSON.parse(xhr.responseText);
        } catch (e) {}

        cb(null, parsed);
      } else {
        cb(xhr.status);
      }
    }
  };
  xhr.open("GET", "/cart.json");
  xhr.send();
}

function RefreshCartDrawer() {
  GetCart(function (err, cart) {
    CartJS.cart = cart;
    jQuery(document).trigger("cart.requestComplete", [cart]);
    jQuery(document).trigger("cart.ready", [cart]);
  });
}

function RP_ServiceDebounceTimer() {
  window.RP_addq.dbt = undefined;
  if (!window.RP_addq.working) {
    window.RP_addq.working = true;

    var param = { items: [] };
    var working = [];
    var items = [];
    for (var i = 0; i < window.RP_addq.q.length; i++) {
      var button = window.RP_addq.q[i];
      var vid = button.getAttribute("data-variant-id");
      var qty = 1;
      var detail = $(button).closest(".rr-recommended-product-detail")[0];
      var qtyInput = detail.querySelector("input.qty-input");
      var qtrStr = qtyInput.value;
      if (qtrStr != undefined) {
        qty = Number(qtrStr);
      }

      param.items.push({
        id: vid,
        quantity: qty,
        properties: { _source: "recommendation" },
      });
      working.push(button);

      var item = {
        productID: button.getAttribute("data-product-id"),
        variantID: button.getAttribute("data-variant-id"),
        price: button.getAttribute("data-price"),
        sku: button.getAttribute("data-sku"),
        qty: qty,
        grams: button.getAttribute("data-grams"),
      };
      items.push(item);
    }
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4) {
        window.RP_addq.working = false;

        var state = "error";
        if (xhr.status == 200) {
          state = "done";
          g_basket.items = g_basket.items.concat(items);
          RefreshCartDrawer();
        }

        for (var i = 0; i < working.length; i++) {
          RP_SetAddButtonState(working[i], state);
        }

        if (window.RP_addq.q.length > 0 && window.RP_addq.dbt == undefined) {
          RP_ServiceDebounceTimer();
        } else if (state == "done") {
          // fetch more products to replace the ones that were added
          var payload = { basket: g_basket, id: g_rr_sessionID };
          RecommendationRequest(
            "/api/recommendations",
            payload,
            function (err, result) {
              ShowProductRecommendations(result);
            }
          );
        }
      }
    };

    window.RP_addq.q = [];

    xhr.open("POST", "/cart/add.js", true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(JSON.stringify(param));
  }
}
function RP_SetAddButtonState(button, state) {
  function BackToStash() {
    if (state == "done") {
      // just remove from the UI
      var product = $(button).closest(".rr-recommended-product")[0];
      product.parentNode.removeChild(product);
    } else if (button.getAttribute("data-stash")) {
      button.innerHTML = button.getAttribute("data-stash");
      button.classList.remove("disabled");
    }
  }

  if (state == "working") {
    button.setAttribute("data-stash", button.innerHTML);
    button.innerHTML = "Working...";
    button.classList.add("disabled");
  } else if (state == "done") {
    button.innerHTML = "Added OK";
    setTimeout(BackToStash, 1000);
  } else if (state == "error") {
    button.innerHTML = "Error";
    setTimeout(BackToStash, 1000);
  }
}
function AddRecommendedProductToBasket(button) {
  console.log("add recommended");
  if (window.RP_addq == undefined) {
    window.RP_addq = { q: [] };
  }

  window.RP_addq.q.push(button);
  RP_SetAddButtonState(button, "working");

  if (window.RP_addq.dbt != undefined) {
    clearTimeout(window.RP_addq.dbt);
    window.RP_addq.dbt = undefined;
  }
  window.RP_addq.dbt = setTimeout(RP_ServiceDebounceTimer, 200);
}

function RP_VariantChanged(e) {
  var sel = e.currentTarget;
  var product = $(sel).closest(".rr-recommended-product")[0];
  var price = product.querySelector(".price-box .price-wrapper .special-price");
  var opt = sel.options[sel.selectedIndex];
  var btn = product.querySelector("button.add_to_cart");

  price.innerHTML = opt.getAttribute("data-price");
  btn.setAttribute("data-variant-id", opt.value);
  btn.setAttribute("data-sku", opt.getAttribute("data-sku"));
  btn.setAttribute("data-grams", opt.getAttribute("data-grams"));
}

function RemoveRecommendationProduct(productID) {
  var selector =
    ".rr-recommended-product[data-pid='" +
    productID +
    "']:not( .slick-cloned )";
  var existing = document.querySelectorAll(selector);

  for (var i = 0; i < existing.length; i++) {
    var item = existing[i];

    // this used to work !
    //var slick = $( item ).closest( ".slick-slider" );
    //var index = $( item ).closest( ".slick-slide" ).attr( "data-slick-index" );

    //slick.slick( "slickRemove", index );

    item.parentNode.removeChild(item);
  }
}

function GetPageUsingAjax(url, cb) {
  var xhr = new XMLHttpRequest();

  xhr.onreadystatechange = function () {
    if (xhr.readyState == 4) {
      cb(xhr, xhr.responseText);
    }
  };

  xhr.open("GET", url, true);
  xhr.send();
}

function UpdateMainCartDisplay() {
  var url = "/cart";
  GetPageUsingAjax(url, function (xhr, markup) {
    var parser = document.createElement("div");
    parser.innerHTML = markup;

    var selectors = ["cart-items", ".cart__footer-wrapper"];

    for (var i = 0; i < selectors.length; i++) {
      var selector = selectors[i];
      var toShow = parser.querySelector(selector);
      var where = document.querySelector(selector);

      where.innerHTML = toShow.innerHTML;
    }
  });
}

function ATCHandler(e) {
  // custom handling below works, but making the sidecart work with it has proven to be tricky
  //e.preventDefault( );
  //e.stopPropagation( );
  //AddRecommendedProductToBasket( e.currentTarget );

  // instead just allow theme base code to run, then update recommendations when it's finished
  var button = e.currentTarget;
  var observer = new MutationObserver(function (ml, o) {
    if (button.getAttribute("style")) {
      observer.disconnect();
      observer.takeRecords();

      var vid = button.getAttribute("data-variant-id");
      var qty = 1;
      var product = $(button).closest(".rr-recommended-product")[0];
      var qtyInput = product.querySelector("input.qty-input");
      var qtrStr = qtyInput.value;
      if (qtrStr != undefined) {
        qty = Number(qtrStr);
      }

      var item = {
        productID: button.getAttribute("data-product-id"),
        variantID: button.getAttribute("data-variant-id"),
        price: button.getAttribute("data-price"),
        sku: button.getAttribute("data-sku"),
        qty: qty,
        grams: button.getAttribute("data-grams"),
      };
      g_basket.items.push(item);
      RemoveRecommendationProduct(item.productID);

      // fetch more products to replace the ones that were added
      var payload = { basket: g_basket, id: g_rr_sessionID };
      RecommendationRequest(
        "/api/recommendations",
        payload,
        function (err, result) {
          ShowProductRecommendations(result);
        }
      );

      UpdateMainCartDisplay();
    }
  });

  observer.observe(button, {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true,
  });
}

function SetATCHandlers() {
  var buttons = document.querySelectorAll(
    ".rr-basket-recommendations-products .add_to_cart:not( .atc-setup )"
  );
  for (var i = 0; i < buttons.length; i++) {
    var button = buttons[i];

    button.addEventListener("click", ATCHandler);
    button.classList.add("atc-setup");
  }
}

function Execute() {
  window.addEventListener("load", function () {
    var ymalRoot = document.getElementById("rr-basket-recommendations-ymal");
    if (ymalRoot.querySelector(".rr-recommended-product")) {
      ymalRoot.classList.remove("hidden");
    }

    if (window.location.pathname.indexOf("/delivery-options") >= 0) {
      SetATCHandlers();

      $(".rr-recommended-product-variant-selector select").on(
        "change",
        RP_VariantChanged
      );
    }
  });
}
//Execute( );

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// updated version May 2022
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function ShowProductRecommendations(result) {
  if (result && result.products) {
    var combined = result.products.also.concat(result.products.orders);
    var widgets = document.querySelectorAll(
      ".sec-ProductRecommendations_Control-personalised"
    );
    if (combined.length > 3 && widgets.length > 0) {
      widgets.forEach(function (widget) {
        // actually displayed in the code below
        widget._productsToShow = combined;
        widget.classList.remove("hidden");

        if (widget._pending) {
          widget._pending.forEach(function (cb) {
            cb();
          });
        }
      });
    }
  }
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// section code moved from custom-product-recommendations.liquid then tweaked to support "you may also like" and "did you forget"
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
window.addEventListener("DOMContentLoaded", (event) => {
  const $slickSlider = $(".sec-ProductRecommendations_Items");
  const $slickSettings = {
    infinite: true,
    dots: false,
    arrows: true,
    appendArrows: $(".sec-ProductRecommendations_Arrows"),
    slidesToShow: 4,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // Get Section Controls
  const productRecommendationControls = document.querySelector(
    ".sec-ProductRecommendations_Controls"
  );
  const showRecentlyViewedItems =
    productRecommendationControls.dataset.recentlyViewed;

  // Check for the user's recently viewed items and check if the user wants those items to be visible.
  const recentlyViewedItems = getCookie(
    "shopify_recently-viewed-products"
  ).split("/");

  function ShowRecommendations(markup) {
    if ($slickSlider[0].classList.contains("slick-initialized")) {
      $slickSlider.slick("unslick");
    }

    document.getElementById("js-ProductRecommendations").innerHTML = markup;

    $slickSlider.slick($slickSettings);
  }

  function ShowPersonalisedRecommendations(button) {
    var markup = "";

    if (button._productsToShow) {
      button._productsToShow.forEach(function (product) {
        var productID = product.product_id;
        var productTitle = product.title;
        var productURL = "/products/" + product.handle;
        var productPrice = product.variants[0].price;
        var productComparePrice = product.variants[0].compare_at_price;
        var productImage = product.image;
        var productVariantID = product.variants[0].id;

        markup += productCardHTML(
          productID,
          productTitle,
          productURL,
          productPrice,
          productComparePrice,
          productImage,
          productVariantID
        );
      });
      ShowRecommendations(markup);
    } else {
      if (button._pending == undefined) {
        button._pending = [];
      }
      button._pending.push(function () {
        ShowPersonalisedRecommendations(button);
      });
    }
  }

  // Fetch the 'Controls', loop over each button with a listener,
  // and request the relevant collection via the data-collection-handle attribute.
  const filterButtons = document.querySelectorAll(
    ".sec-ProductRecommendations_Control"
  );

  filterButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      const collectionHandle = event.target.getAttribute(
        "data-collection-handle"
      );

      filterButtons.forEach((button) => {
        button.removeAttribute("toggled");
      });

      event.target.setAttribute("toggled", "");

      if (
        event.target.classList.contains(
          "sec-ProductRecommendations_Control-personalised"
        )
      ) {
        ShowPersonalisedRecommendations(event.target);
      } else if (collectionHandle != "recently-viewed") {
        requestCollection(collectionHandle);
      } else {
        const recentlyViewedItems = getCookie(
          "shopify_recently-viewed-products"
        ).split("/");

        requestRecentlyViewed(recentlyViewedItems);
      }
    });
  });

  // Initialise collection: 'Recently Viewed'.
  // $( ".sec-ProductRecommendations .sec-ProductRecommendations_Controls .sec-ProductRecommendations_Control:first-child" ).click( );
  // dr change
  $(
    ".sec-ProductRecommendations .sec-ProductRecommendations_Controls .sec-ProductRecommendations_Control:first-child"
  );

  // Fetch 'Recently Viewed' products.
async function requestRecentlyViewed(recentlyViewedItems) {
  var productCard = "";

  await Promise.all(
    recentlyViewedItems.map(async (item) => {
      const response = await fetch(`/products/${item}.json`);
      const json = await response.json();
      const product = json.product;

      var productID = product.id;
      var productTitle = product.title;
      var productURL = "/products/" + product.handle;
      var productPrice = product.variants[0].price;
      var productComparePrice = product.variants[0].compare_at_price;
      var productImage = product.images[0].src;
      var productVariantID = product.variants[0].id;
      var productInventory = product.variants[0].inventory_quantity;

      productCard += productCardHTML(
        productID,
        productTitle,
        productURL,
        productPrice,
        productComparePrice,
        productImage,
        productVariantID,
        productInventory 
      );
    })
  );

  ShowRecommendations(productCard);
}

  // Fetch 'Collection' products.
  async function requestCollection(collectionHandle) {
    const response = await fetch(
      `/collections/${collectionHandle}/products.json`
    );
    const json = await response.json();
    const products = json.products;
    var productCard = "";

    products.forEach((product) => {
      var productID = product.id;
      var productTitle = product.title;
      var productURL = "/products/" + product.handle;
      var productPrice = product.variants[0].price;
      var productComparePrice = product.variants[0].compare_at_price;
      var productImage = product.images[0].src;
      var productVariantID = product.variants[0].id;

      productCard += productCardHTML(
        productID,
        productTitle,
        productURL,
        productPrice,
        productComparePrice,
        productImage,
        productVariantID
      );
    });

    ShowRecommendations(productCard);
  }

  function productCardHTML(
    productID,
    productTitle,
    productURL,
    productPrice,
    productComparePrice,
    productImage,
    productVariantID,
    productInventory
  ) {
    const productPriceForm = productComparePrice
      ? `<div class="price__sale">
                                             <dt class="price__compare">
            <span class="visually-hidden visually-hidden--inline">
                        Regular price
                        </span>
                        </dt>
                        <dd class="price__compare">
                                  <s class="price-item price-item--regular">
                                           £` +
        productComparePrice +
        `
                                           </s>
                                           </dd>
                                           <dt>
                                           <span class="visually-hidden visually-hidden--inline">
            Sale price
            </span>
            </dt>
            <dd>
            <span class="price-item price-item--sale">
                        £` +
        productPrice +
        `
                        </span>
                        </dd>
                        </div>`
      : `<div class="price__regular">
                                    <dt>
                                    <span class="visually-hidden visually-hidden--inline">
                                                Regular price
                                                </span>
                                                </dt>
                                                <dd>
                                                <span class="price-item price-item--regular">
            £` +
        productPrice +
        `
            </span>
            </dd>
            </div>`;

    return (
      `
                <li class="sec-ProductRecommendations_Item" qty="` +
      productInventory +
      `">
                          <div class="card-wrapper">
                                     <a href="` +
      productURL +
      `" class=""full-unstyled-link" tabindex="0">
            <span class="visually-hidden">` +
      productTitle +
      `</span>
                        <div class="card card--product" tabindex="-1">
            <div class="card__inner">
                       <div>
                       <div class="media media--transparent media-- media--hover-effect">
                                  <img src="` +
      productImage +
      `" alt="` +
      productTitle +
      `" loading="lazy" class="motion-reduce" width="800" height="800">
            </div>
            </div>
            <div class="card__badge"></div>
                       </div>
                       </div>
                       <div class="card-information">
                                  <div class="card-information__wrapper">
                                             <span class="card-information__text h5">
            ` +
      productTitle +
      `
            </span>
            <span class="caption-large light"></span>
                        <div class="price">
                                   <dl>` +
      productPriceForm +
      `</dl>
                                   </div>
                                   </div>
                                   </div>
                                   </a>
                                   <div class="addToCart">
                                              <div class="product-page-review-wrapper">
            <div class="loox-rating" data-fetch data-id="` +
      productID +
      `" data-rating="{{ product.metafields.loox.avg_rating }}" data-raters="{{ product.metafields.loox.num_reviews }}" data-pattern="[rating] ([count])"></div>
            </div>
            <form method="post" action="/cart/add" id="product-form-` +
      productVariantID +
      `" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
            <input type="hidden" name="form_type" value="product" tabindex="0">
            <input type="hidden" name="utf8" value="✓" tabindex="0">
            <input type="hidden" name="id" value="` +
      productVariantID +
      `" tabindex="0">
            <div class="product-form__buttons">
                       <button type="submit" name="add" class="add_to_cart_product_page product-form__submit button button--full-width button--primary" tabindex="0">
            Add to cart
            </button>

            <div class="qtydiv" style="display: none;">
                                      <div class="qtybox">
            <button type="button" class="btnqty qtyminus icon icon-minus decrease" tabindex="0"></button>
            <input type="text" name="quantity" value="" min="1" data-variant-id="` +
      productVariantID +
      `" data-min="1" data-cart-quantity="1" class="quantity-selector quantity-input" readonly="" tabindex="0">
            <button type="button" class="btnqty qtyplus icon icon-plus increase" tabindex="0"></button>
            </div>
            </div>
            </div>
            </form>
            </div>
            </div>
            </li>`
    );
  }
});
